/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_FamilyInputs */

const en_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Family`)
};

const th_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตระกูล`)
};

const ja_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファミリー`)
};

const fr_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Famille`)
};

const es_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Familia`)
};

const ru_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Семейство`)
};

const zh_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品系`)
};

const vi_attr_family = /** @type {(inputs: Attr_FamilyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng giống`)
};

/**
* | output |
* | --- |
* | "Family" |
*
* @param {Attr_FamilyInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_family = /** @type {((inputs?: Attr_FamilyInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_FamilyInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_family(inputs)
	if (locale === "ja") return ja_attr_family(inputs)
	if (locale === "fr") return fr_attr_family(inputs)
	if (locale === "es") return es_attr_family(inputs)
	if (locale === "ru") return ru_attr_family(inputs)
	if (locale === "zh") return zh_attr_family(inputs)
	if (locale === "vi") return vi_attr_family(inputs)
	return en_attr_family(inputs)
});